export default __webpack_public_path__ + "static/media/people.4bdcc4b7.jpg";